import React from 'react';
import { ModuleBase, Stack, ResponsiveImage, Text } from '@/components';
import { SideBySideModuleModel } from './SideBySideModule';
import classNames from 'classnames';
import { fadeIn } from '@/animations';

const ICPExpert = (data: SideBySideModuleModel) => {
  const {
    props: { alignment, image, title, preTitle, description },
  } = data;

  return (
    <ModuleBase data={data} noPadding className="ICPExpert overflow-hidden pt-10 lg:py-18">
      <Stack
        className={classNames(
          'container flex flex-col justify-between gap-6 lg:items-stretch lg:gap-0',
          alignment === 'Right' ? 'lg:flex-row-reverse' : 'lg:flex-row',
        )}
      >
        <div className="flex w-full flex-grow flex-col gap-6 lg:w-1/2 lg:gap-16">
          <div>
            <Text className="text-style-tag uppercase">{preTitle}</Text>
            {title && <Text className="text-style-h3 mt-5" dangerouslySetInnerHTML={{ __html: title }} />}
          </div>
          <Text
            className="text-style-body [&_.largerText]:text-style-h4 mt-5 [&_.largerText]:leading-12"
            dangerouslySetInnerHTML={{ __html: description || '' }}
          />
        </div>
        <div className="relative w-full flex-grow lg:w-1/2">
          <div className={classNames(alignment === 'Right' ? 'lg:pr-18 lg:pl-9' : 'lg:pr-9 lg:pl-18', 'h-full')}>
            <div className="xxl:aspect-[575/575] -mr-5 -ml-5 aspect-square h-full overflow-hidden md:-mr-9 md:-ml-9 lg:mr-0 lg:ml-0 lg:aspect-[575/600]">
              {image && image.desktopImage && (
                <ResponsiveImage
                  animation={fadeIn}
                  image={image.desktopImage}
                  widths={{ xs: 425, sm: 650, md: 768, lg: 520, xl: 576, xxl: 656 }}
                  heights={{ xs: 425, sm: 650, md: 768, lg: 540, xl: 600, xxl: 685 }}
                />
              )}
            </div>
          </div>
        </div>
      </Stack>
    </ModuleBase>
  );
};

export default ICPExpert;
